import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef, createRef } from 'react';
import '@aws-amplify/ui-react/styles.css';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DataTable from 'react-data-table-component';
import PulseLoader from 'react-spinners/PulseLoader';
import ModalChannel from './ModalChannel';
import { SubjectLayout } from 'layouts/SubjectLayout';
import { channelAPI } from 'services/admin';

function Channels() {
  const [totalItems, setTotalItems] = useState(); //total de resultados retornado pela consulta de usuários

  const [itemsPerPage, setItemsPerPage] = useState(); //exibicao da posicao de itens que está sendo exibido no footer da página
  const [itemsInitialPage, setItemsInitialPage] = useState(1);

  const [actualPage, setActualPage] = useState(1); //numero exibido indicando qual a pagina atual que ele está

  const [userItems, setUserItems] = useState([]); //resultado da consulta
  const [filterPath, setFilterPath] = useState(''); //resultado da consulta

  const offSetItems = useRef(0);

  const inputChannel = createRef();

  const [pending, setPending] = useState(true);

  const [open, setOpen] = useState(false);
  const [action, setAction] = useState('');
  const [channelProps, setChannelProps] = useState({});

  const [filterApplied, setFilterApplied] = useState(false);
  const [channelFiltered, setChannelFiltered] = useState('');

  const navigate = useNavigate();

  const handleOpen = action => {
    setAction(action);
    setOpen(true);
  };

  const handleButtonClick = (e, id) => {
    e.preventDefault();
    setChannelProps(id);
    handleOpen('edit');
  };

  // Hyperlink
  function goToSelectedFilteredPage(e, channelName, channelId, path) {
    e.preventDefault();
    let channel = JSON.stringify({ label: channelName, value: channelId });
    navigate(`/${path}?canal=${channel}`);
  }

  const columns = [
    {
      id: 1,
      name: 'Nome do Canal',
      selector: row => row.name,
      width: '35%',
      sortable: true,
    },
    {
      id: 3,
      name: 'Vídeos Vinculados',
      selector: row =>
        row.linkedVideos === undefined
          ? ''
          : row.linkedVideosCount === 0
            ? ''
            : row.linkedVideosCount,
      width: '20%',
      center: 'true',
      cell: row => (
        <div
          className={
            row.linkedVideos === undefined
              ? 'datatable_prevent_click'
              : row.linkedVideosCount === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={e =>
            goToSelectedFilteredPage(e, row.name, row.id, 'videos')
          }>
          {row.linkedVideos === undefined
            ? '-'
            : row.linkedVideosCount === 0
              ? '-'
              : row.linkedVideosCount}
        </div>
      ),
    },
    {
      id: 4,
      name: 'Coleções Vinculadas',
      selector: row =>
        row.linkedCollections === undefined
          ? ''
          : row.linkedCollectionsCount === 0
            ? ''
            : row.linkedCollectionsCount,
      width: '20%',
      center: 'true',
      cell: row => (
        <div
          className={
            row.linkedCollections === undefined
              ? 'datatable_prevent_click'
              : row.linkedCollectionsCount === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={e =>
            goToSelectedFilteredPage(e, row.name, row.id, 'colecoes')
          }>
          {row.linkedCollections === undefined
            ? '-'
            : row.linkedCollectionsCount === 0
              ? '-'
              : row.linkedCollectionsCount}
        </div>
      ),
    },
    {
      id: 5,
      name: 'Usuários Vinculados',
      selector: row =>
        row.linkedUsers === undefined
          ? ''
          : row.linkedUsersCount === 0
            ? ''
            : row.linkedUsersCount,
      width: '19%',
      center: 'true',
      cell: row => (
        <div
          className={
            row.linkedUsers === undefined
              ? 'datatable_prevent_click'
              : row.linkedUsersCount === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={e =>
            goToSelectedFilteredPage(e, row.name, row.id, 'usuarios')
          }>
          {row.linkedUsers === undefined
            ? '-'
            : row.linkedUsersCount === 0
              ? '-'
              : row.linkedUsersCount}
        </div>
      ),
    },
    {
      id: 6,
      name: '',
      width: '6%',
      cell: row => (
        <div
          className="user_datatable_pointer"
          onClick={e => handleButtonClick(e, row)}>
          <img
            src="/img/datatable_edit_icon.svg"
            alt="Logo"
            style={{ width: '25px', height: '25px' }}
          />
        </div>
      ),
    },
  ];

  const channelDataTablePagination = arrowDirection => {
    setPending(true);
    if (arrowDirection === 'right') {
      offSetItems.current += 10;
    } else if (arrowDirection === 'left') {
      offSetItems.current -= 10;
    }

    const path =
      '?limit=10&sortBy=name&offset=' + offSetItems.current + filterPath;

    channelAPI
      .get(path)
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.channelList);

        if (arrowDirection === 'right') {
          setItemsInitialPage(itemsInitialPage + 10);
          setActualPage(actualPage + 1);
          setItemsPerPage(itemsPerPage + resp.channelList.length);
          setPending(false);
        } else if (arrowDirection === 'left') {
          setItemsPerPage(itemsPerPage - userItems.length);
          setItemsInitialPage(itemsInitialPage - 10);
          setActualPage(actualPage - 1);
          setPending(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const removeFilter = () => {
    setFilterApplied(false);
    inputChannel.current.value = null;
    setChannelFiltered('');
    setFilterPath('');
  };

  const applyFilter = () => {
    setFilterApplied(true);

    let inputChannelPath = '';
    if (inputChannel.current.value !== '') {
      inputChannelPath += '&name=' + inputChannel.current.value;
      setChannelFiltered(inputChannel.current.value);
    } else {
      setChannelFiltered('');
    }

    let path = inputChannelPath;
    setFilterPath(path);
  };

  useEffect(() => {
    // Este trecho de código será executado após filterPath ser atualizado
    setActualPage(1);
    setItemsInitialPage(1);
    offSetItems.current = 0;
    channelDataTableGetItems();
  }, [filterPath]);

  const channelDataTableGetItems = () => {
    setPending(true);
    setActualPage(1);
    setItemsInitialPage(1);
    offSetItems.current = 0;
    const path =
      '?limit=10&sortBy=name&offset=' + offSetItems.current + filterPath;

    channelAPI
      .get(path)
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.channelList);

        if (resp.channelList.length === 0) {
          setItemsInitialPage(0);
        }

        if (resp.totalItemsCountFiltered <= 10) {
          setItemsPerPage(resp.totalItemsCountFiltered);
        } else {
          setItemsPerPage(resp.channelList.length);
        }
        setPending(false);
      })
      .catch(error => {
        console.log(error);
        setPending(false);
      });
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: '50px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#475467',
        fontWeight: '500',
        backgroundColor: 'var(--gray-50, #F9FAFB)',
        // borderBottom: '1px solid var(--gray-200, #EAECF0)',
        width: 'auto',
      },
    },
    cells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#6F6B7D',
        // backgroundColor: '#EAECF0',
        width: 'auto',
      },
    },
  };
  const enterPresskey = event => {
    if (event.keyCode === 13) {
      applyFilter();
    }
  };

  return (
    <SubjectLayout.Root id="main-channels">
      <SubjectLayout.Title>
        <div className="unit_title_page1">Cadastro/</div>
        <div className="unit_title_page2">Canal</div>
      </SubjectLayout.Title>
      <SubjectLayout.IconButton
        onClick={() => {
          setChannelProps({});
          handleOpen('create');
        }}>
        Canal
      </SubjectLayout.IconButton>
      <SubjectLayout.InnerContainer>
        <div className="datatable_content">
          <div className="user_data_table_title">Canais</div>
          <div>
            <div className="user_datatable_filter_title">Filtros</div>
            <section id="user_container">
              <div className="user_datatable_filter filter_input_spacing">
                <TextField
                  inputProps={{
                    style: {
                      height: '21px',
                    },
                  }}
                  sx={{
                    '& .MuiFormLabel-root': {
                      color: '#B7B5BE',
                      fontSize: '15px',
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor:
                        'var(--light-solid-color-extra-card-background, #FFF)',
                    },
                    '& .MuiOutlinedInput-root': {
                      // '& fieldset': { border: '1px solid var(--light-solid-color-extra-divider, #DBDADE)', borderRadius: '6px' },
                      // '&:hover fieldset': { borderColor: '#1361A4' }
                    },
                  }}
                  label={
                    <div style={{ display: 'inline-block' }}>
                      <SearchIcon fontSize="small" />
                      Buscar por canal
                    </div>
                  }
                  placeholder="Canal"
                  id="outlined-size-small"
                  defaultValue=""
                  size="small"
                  inputRef={inputChannel}
                  onKeyDown={e => enterPresskey(e)}
                />
              </div>

              <div className="user_datatable_filter ">
                <Button
                  sx={{
                    width: 'auto',
                    height: '38px',
                    borderRadius: '8px',
                    color: '#1361A4',
                    border: '1px solid #D7E8F7',
                    background: 'var(--base-white, #FFF)',
                    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                    textTransform: 'capitalize',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '24px',
                  }}
                  onClick={applyFilter}
                  variant="outlined"
                  startIcon={<SearchIcon />}>
                  Aplicar Filtro
                </Button>
              </div>
            </section>

            <section id="user_container">
              <div
                className={
                  filterApplied === true &&
                  channelFiltered !== undefined &&
                  channelFiltered !== null &&
                  channelFiltered !== ''
                    ? 'user_datatable_filtered_values'
                    : ''
                }>
                {filterApplied === true ? (
                  channelFiltered === undefined ? (
                    ''
                  ) : channelFiltered === '' ? (
                    ''
                  ) : channelFiltered === null ? (
                    ''
                  ) : (
                    <div className="filtered_content_main">
                      <div className="filtered_content_title">Canal: </div>
                      <div className="filtered_content_content">
                        {channelFiltered}
                      </div>
                    </div>
                  )
                ) : null}
              </div>

              {filterApplied === true && channelFiltered !== '' && (
                <div
                  className="user_datatable_clean_filter"
                  onClick={removeFilter}>
                  Limpar Filtros
                </div>
              )}
            </section>
          </div>
          <div className="user_datatable_width">
            <DataTable
              columns={columns}
              data={userItems}
              customStyles={customStyles}
              progressPending={pending}
              progressComponent={
                <p className="user_datatable_loading">
                  Buscando Informações...{' '}
                  <PulseLoader
                    color="#1361A4"
                    className="user_datatable_loader"
                  />
                </p>
              }
              highlightOnHover
              noDataComponent={
                <div className="user_datatable_loading">
                  <div>
                    <svg
                      width="27"
                      height="24"
                      viewBox="0 0 27 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        id="Vector"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.3805 15.2341C23.0181 15.2341 23.3823 14.5064 23 13.9961L21 10.9961C20.5375 10.2277 19.7062 9.7578 18.8094 9.7578H7.62658C7.07618 9.7578 6.56235 10.0334 6.25792 10.492L4.5667 13.0393C4.56552 13.0411 4.5668 13.0435 4.56893 13.0435C4.57107 13.0435 4.57234 13.0459 4.57117 13.0476L3.85 14.1388C3.53979 14.6081 3.87636 15.234 4.43896 15.234H7.75886C9.13473 15.234 10.2013 16.4939 11.1434 17.4966C11.7356 18.1268 12.5724 18.5197 13.5001 18.5197C14.4626 18.5197 15.3275 18.0967 15.9225 17.4245C16.7988 16.4347 17.8217 15.234 19.1437 15.234L22.3805 15.2341ZM25.8324 14.2286C26.2678 14.8843 26.5 15.654 26.5 16.4411V19.9961C26.5 22.2052 24.7091 23.9961 22.5 23.9961H4.5C2.29086 23.9961 0.5 22.2052 0.5 19.9961V16.4412C0.5 15.654 0.732258 14.8843 1.16768 14.2285L4.40363 9.35504C5.14488 8.23868 6.3959 7.56766 7.73594 7.56766H19.2644C20.6045 7.56766 21.8556 8.23874 22.5968 9.35518L25.8324 14.2286ZM9.87597 19.3045C8.83173 18.3534 7.61948 17.4246 6.20703 17.4246H4.85678C3.64704 17.4246 2.66636 18.4053 2.66636 19.6151C2.66636 20.8248 3.64704 21.8055 4.85678 21.8055H22.1423C23.352 21.8055 24.3327 20.8248 24.3327 19.6151C24.3327 18.4053 23.352 17.4246 22.1423 17.4246H20.7921C19.3796 17.4246 18.1673 18.3535 17.1229 19.3044C16.1631 20.1784 14.8925 20.7103 13.4991 20.7103C12.1056 20.7103 10.8355 20.1784 9.87597 19.3045ZM14.5832 4.29368C14.5832 4.89195 14.0982 5.37695 13.4999 5.37695C12.9016 5.37695 12.4166 4.89195 12.4166 4.29368V2.07936C12.4166 1.48109 12.9016 0.996094 13.4999 0.996094C14.0982 0.996094 14.5832 1.48109 14.5832 2.07936V4.29368ZM20.4458 5.20593C20.068 5.67893 19.3767 5.7525 18.9077 5.36962C18.4458 4.99246 18.3736 4.31374 18.7458 3.84781L20.0124 2.26227C20.3903 1.78928 21.0816 1.71571 21.5505 2.09859C22.0125 2.47575 22.0847 3.15447 21.7125 3.6204L20.4458 5.20593ZM8.25399 3.84781C8.6262 4.31373 8.55397 4.99246 8.09204 5.36962C7.62309 5.7525 6.9318 5.67893 6.55393 5.20593L5.2873 3.6204C4.91508 3.15447 4.98731 2.47575 5.44925 2.09859C5.91819 1.71571 6.60949 1.78928 6.98735 2.26227L8.25399 3.84781Z"
                        fill="#344054"
                      />
                    </svg>
                  </div>
                  <p className="datatable_nodata_text">
                    Não encontramos registros para os dados informados.
                  </p>
                </div>
              }
              defaultSortFieldId={1}
              defaultSortAsc={true}
              sortIcon={<ArrowDropDownIcon color="#1361A4" />}></DataTable>
          </div>
          <div className="user_data_table_footer">
            <div className="user_data_table_footer_total">
              {itemsInitialPage} - {itemsPerPage} de {totalItems}
            </div>
            <div className="user_data_table_footer_pages">
              <KeyboardArrowLeftIcon
                className={
                  actualPage == 1
                    ? 'user_datatable_disabled_left_arrow'
                    : 'user_datatable_left_arrow'
                }
                onClick={() => channelDataTablePagination('left')}
              />
              {actualPage}
              <KeyboardArrowRightIcon
                className={
                  totalItems <= 10
                    ? 'user_datatable_disabled_right_arrow'
                    : itemsPerPage === totalItems
                      ? 'user_datatable_disabled_right_arrow'
                      : 'user_datatable_right_arrow'
                }
                onClick={() => channelDataTablePagination('right')}
              />
            </div>
          </div>
        </div>
      </SubjectLayout.InnerContainer>
      <ModalChannel
        open={open}
        action={action}
        channel={channelProps}
        onClose={() => setOpen(false)}
        getChannels={channelDataTableGetItems}
      />
    </SubjectLayout.Root>
  );
}

export default Channels;
